import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// material-ui
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import ContentAdd from 'material-ui/svg-icons/content/add';
// sorted
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import * as TVShowOrderEditMutation from '../../mutations/TVShowOrderEditMutation';
import * as TVShowsOrderNormalize from '../../mutations/TVShowsOrderNormalize';
import { ContentSort } from 'material-ui/svg-icons';
// Отображение скрытых материалов
import ShowHiddenElement from '../showHiddenElement/index';
// styles
import { colors, containerHeader, paperStyle, styles } from '../../lib/styles';
import './styles.css';
import { NativeDataGrid } from '../ui/data-grid/data-grid';
import { Select } from '../ui/select/select';
import Icon from '../ui/icon/icon';

type Props = {
	history: Object,
	relay: Object,
	viewer: Object,
};

const SortableTableBody = SortableContainer(({ children }) => {
	return <tbody>{children}</tbody>;
});
const SortableIcon = SortableHandle(({ tabIndex }) => (
	<div tabIndex={tabIndex}>
		<ContentSort />
	</div>
));

const translations = {
	available: 'Доступно',
	archive: 'Архив',
	deleted: 'Удалено',
};

const SortableRow = SortableElement(({ title, id, state, isProject, onClick, categoryName }) => (
	<tr onClick={() => onClick(id)}>
		<td>
			<SortableIcon />
		</td>
		<td>{title}</td>
		<td>{categoryName}</td>
		<td>{translations[state]}</td>
		<td>{isProject ? 'Да' : 'Нет'}</td>
	</tr>
));

const availableStatuses = ['available', 'archive', 'deleted'];
const allOptionValue = 'all';

const statusesOption = [
	{
		value: allOptionValue,
		text: 'Все',
	},
	{
		value: 'available',
		text: 'Доступные',
	},
	{
		value: 'archive',
		text: 'Архивные',
	},
	{
		value: 'deleted',
		text: 'Удаленные',
	},
];

const columns = [
	{ title: 'Cорт', width: '10%' },
	{ title: 'Название', width: '30%' },
	{ title: 'Рубрика', width: '20%' },
	{ title: 'Статус', width: '20%' },
	{ title: 'Проект', width: '20%' }
];

class TVShowApp extends React.Component<Props> {
	state = {
		filterStatuses: ['all'],
		onlyProject: false,
		tvshows: this.props.viewer.tvshows.tvShows,
	};

	componentWillReceiveProps(nextProps) {
		const nextShows = nextProps.viewer.tvshows;
		this.setState({
			tvshows: nextShows ? nextShows.tvShows : [],
		});
	}

	componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>) {
		const filterStatusChanged =
			prevState.filterStatuses.length !== this.state.filterStatuses.length ||
			!this.state.filterStatuses.every((st, index) => prevState.filterStatuses[index] === st);

		if (filterStatusChanged || this.state.onlyProject !== prevState.onlyProject) {
			this.refetch();
		}
	}

	onDragEnd = ({ oldIndex, newIndex }) => {
		if (newIndex === oldIndex) {
			return;
		}
		const selectedItem = this.state.tvshows[oldIndex];
		TVShowOrderEditMutation.commit(
			this.props.relay.environment,
			{
				id: selectedItem.id,
				order: newIndex,
			},
			error => {
				if (error) {
					console.log(error);
				} else {
					this.refetch();
				}
			},
		);
	};

	handleChangeStatusesValue = value => {
		if (value.length === 1 && value[0] === allOptionValue) {
			this.setState({
				filterStatuses: [allOptionValue],
			});
		} else {
			const index = value.findIndex(v => v === allOptionValue);
			this.setState({
				filterStatuses: index !== -1 && index !== 0 ? [allOptionValue] : value.filter(v => v !== allOptionValue),
			});
		}
	};

	refetch() {
		const statuses = availableStatuses.filter(st => this.state.filterStatuses.includes(st));
		const vars = () => ({
			page: 1,
			isProject: this.state.onlyProject,
			states: statuses.length === 0 ? availableStatuses : statuses,
		});

		console.log(vars());

		this.props.relay.refetch(vars, null, () => { });
	}

	handleNormalize = () => {
		TVShowsOrderNormalize.commit(this.props.relay.environment, {}, error => {
			if (error) {
				console.log(error);
			} else {
				this.refetch();
			}
		});
	};

	handleSortStart = ({ node }) => {
		const tds = document.getElementsByClassName('SortableHelper')[0].childNodes;
		node.childNodes.forEach((node, idx) => (tds[idx].style.width = `${node.offsetWidth}px`));
	};

	redirect = id => {
		this.props.history.push(`/shows/${id}`);
	};

	render() {
		const items = this.state.tvshows;
		return (
			<section>
				<Paper style={{ ...paperStyle.mainItem }}>
					<header
						style={{
							paddingTop: 5,
							paddingBottom: 0,
							...containerHeader.header,
							marginBottom: 5,
							alignItems: 'none',
						}}
					>
						<h3 style={{ ...styles.headerTitle, marginTop: 20 }}>Программы {items.length}</h3>
						<div style={{ flexGrow: 1, alignSelf: 'center' }} />
						<div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
							<Checkbox
								style={{ whiteSpace: 'nowrap', width: 'auto' }}
								label="Только проекты"
								onCheck={(_, checked) => {
									this.setState({
										onlyProject: checked,
									});
								}}
							/>
							<Select multiple value={this.state.filterStatuses} onChange={this.handleChangeStatusesValue} options={statusesOption} />

							<FlatButton
								style={{ ...styles.headerButton, marginLeft: 0, marginRight: 0 }}
								label="Создать"
								primary
								icon={<ContentAdd />}
								onClick={() => this.props.history.push('/shows/new')}
							/>
							<RaisedButton primary onClick={this.handleNormalize} label="Нормализовать порядок" />
						</div>
					</header>

					<NativeDataGrid columns={columns} items={items}>
						<SortableTableBody
							pressDelay={10}
							helperClass="SortableHelper"
							onSortEnd={this.onDragEnd}
							onSortStart={this.handleSortStart}
							useDragHandle
							useWindowAsScrollContainer
						>
							{items.map((row, ix) => (
								<SortableRow onClick={this.redirect} key={`row-${ix}`} index={ix} {...row} />
							))}
						</SortableTableBody>
					</NativeDataGrid>
				</Paper>
			</section>
		);
	}
}

export default withRouter(
	createRefetchContainer(
		TVShowApp,
		graphql`
			fragment TVShowApp_viewer on Viewer
				@argumentDefinitions(page: { type: "Int!" }, isProject: { type: Boolean }, states: { type: "[String]" }) {
				tvshows: tvshowsPaginate(pageSize: 100, isProject: $isProject, page: $page, states: $states) {
					totalCount
					tvShows {
						id
						title
						categoryName
						order
						isProject
						state
					}
				}
			}
		`,
		graphql`
			query TVShowApp_Refetch_Query($page: Int!, $isProject: Boolean,  $states: [String]) {
				viewer {
					...TVShowApp_viewer @arguments(page: $page, isProject: $isProject, states: $states)
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/tvshow/TVShowApp.js